import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ChargingHistoryContainer = styled.div`
  height: 100%;
`;
export const ResumeTitle = styled.div``;
export const ResumeContent = styled.div`
  > div {
    margin-top: ${pxToRem('15px')};
  }
`;
export const ResumeContentItem = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const HistoryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${pxToRem('20px')};
  padding-bottom: ${pxToRem('20px')};
`;
export const HistoryChart = styled.div`
  width: 65%;
`;
export const HistoryTable = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${pxToRem('25px')};
`;
export const Date = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const Kwh = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const Session = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
